import React from "react";
import line from "./line.png";

function Heading(props) {
  return (
    <div className="line-position">
      <h1 className="about-title">{props.title}</h1>
      <img src={line} alt={props.alt} />
    </div>
  );
}

export default Heading;
